package com.yendo.mx.utils

actual fun logFirebaseEvent(name: String, params: Map<String, String>) {
    println("ANALYTICS_WEB: Event $name -> $params")
}
